<template>
  <div id="add-user">
    <v-btn block class="button-add-user" @click="dialog = true">
      <v-icon left>mdi-plus-circle-outline</v-icon>
      เพิ่มอีเมล template
    </v-btn>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title class="tw-mt-4">
          <div class="tw-font-bold tw-text-xl">เพิ่มอีเมล template</div>
        </v-card-title>
        <v-card-text class="tw-pb-0">
          <v-row>
            <v-col>
              <v-text-field
                v-model="emailTemplateID"
                label="อีเมล template ID"
                single-line
                outlined
                class="input-style"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <save-alert
          :status="
            emailStatus && (emailStatus === 'success' ? 'success' : 'error')
          "
          :error-text="alertText[emailStatus]"
          success-text="ส่งอีเมลลงทะเบียนสำเร็จ"
          v-if="emailStatus"
        ></save-alert>
        <v-card-actions class="tw-mb-2">
          <v-spacer></v-spacer>
          <v-btn
            color="#6ec39b"
            text
            @click="saveEmailTemplate"
            class="tw-tracking-normal tw-text-lg tw-mr-2"
          >
            บันทึก
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import firebase from "firebase/app";
import "firebase/auth";
import fc from "@/firebaseConfig";
import SaveAlert from "../save-alert";

// const axios = require("axios");

export default {
  name: "AddEmailTemplate",
  components: {
    SaveAlert
  },
  data() {
    return {
      emailTemplateID: null,
      dialog: false,
      role: "owner",
      emailStatus: null,
      alertText: {
        error: "เพิ่มอีเมล template ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
        sendError: "ไม่สามารถส่งอีเมลได้ กรุณาตรวจสอบอีเมลและลองใหม่อีกครั้ง"
      }
    };
  },
  computed: mapState({
    selectedCompany: state => state.companies.selectedCompany,
    userSearch: state => state.user.userSearch
  }),
  methods: {
    saveEmailTemplate: async function() {
      const companyID = this.$route.params.companyId;
      // alert(this.emailTemplateID);
      await fc.db
        .doc(`Companies/${companyID}/EmailTemplates/${this.emailTemplateID}`)
        .set(
          {
            title: "",
            body: ""
          },
          { merge: true }
        );

      this.dialog = false;
    }
  },
  watch: {
    dialog: {
      handler: function() {
        if (!this.dialog) {
          this.emailStatus = null;
          this.emailTemplateID = null;
          this.role = "owner";
        }
      }
    }
  }
};
</script>

<style lang="scss">
#add-user {
  .v-application .headline {
    font-family: "Noto Sans Thai", "Noto Sans", sans-serif !important;
  }

  .input-style.v-input .v-input__slot {
    border-radius: 10px;
  }

  .v-text-field__details {
    display: none !important;
  }

  .button-add-user {
    background-color: white !important;
    border-top: thin solid #6ec39b;
    border-bottom: thin solid #6ec39b;
    box-shadow: unset !important;
    border-radius: unset;
  }

  .alert-detail {
    padding-left: 20px;
    padding-right: 20px;
  }
}
</style>
